export default __webpack_public_path__ + "static/ruhrbania-6d1ac2ac1c4c9ba252cd473bfac5af7d.jpg";